// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import '../styles/counter.css';

export default class MatchCounter extends React.Component {
    render = () => {
        const idx = this.props.idx;
        const count = this.props.count;
        return (<div className={"match-counter" + (this.props.className ? " " + this.props.className : '')}>
        <div
            className="match-counter-button"
            onClick={() => this.props.goto(0)}
        >«</div>
        <div
            className="match-counter-button"
            onClick={() => this.props.goto(idx > 0 ? idx-1 : 0)}
        >‹</div>
        <div
            className="match-counter-value"
        >{idx+1} of {count}</div>
        <div
            className="match-counter-button"
            onClick={() => this.props.goto(idx < count-1 ? idx+1 : count-1)}
        >›</div>
        <div
            className="match-counter-button"
            onClick={() => this.props.goto(count-1)}
        >»</div>
    </div>);
    }

};